import { render, staticRenderFns } from "./ArchiveResults.vue?vue&type=template&id=b31fff74&scoped=true&"
import script from "./ArchiveResults.vue?vue&type=script&lang=js&"
export * from "./ArchiveResults.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveResults.vue?vue&type=style&index=0&id=b31fff74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31fff74",
  null
  
)

export default component.exports